import { FC, useRef } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, Input } from '@mui/material';
import { useTranslation } from 'mir-utils/i18n';

type Props = {
  searchText: string;
  updateFilter: (val: string) => void;
};

/**
 * @summary Текстовое поле для поиска.
 */
export const IdecoSearchTextField: FC<Props> = ({ searchText, updateFilter }) => {
  const inputRef = useRef<HTMLInputElement>();
  const { t } = useTranslation();

  return (
    <Input
      fullWidth
      value={searchText}
      autoFocus
      onChange={(e) => updateFilter(e.target.value)}
      placeholder={t('Search')}
      startAdornment={
        <IconButton disabled size="small">
          <SearchIcon />
        </IconButton>
      }
      endAdornment={
        searchText && (
          <IconButton size="small" onClick={() => updateFilter('')}>
            <ClearIcon fontSize="small" />
          </IconButton>
        )
      }
      sx={{
        marginBottom: 1,
        padding: 0.75,
      }}
      inputProps={{
        sx: {
          padding: 0,
        },
        ref: inputRef,
      }}
    />
  );
};
